import React, { useState } from "react";
import { MdDelete, MdDownload, MdEdit, MdSearch } from "react-icons/md";
import { TiPlus } from "react-icons/ti";
import useTableApi from '../TableApi.js';
import ConfirmModal from "../Modals/ConfirmModal.js";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai";
import { IconContext } from "react-icons";
import { jsonToXlsx } from "../../Services/commonHelper.js";

const Table = ({ api, columns, title, addModal, showAddButton, showExportButton, deleteApi, disableEdit }) => {
  const { pageIndex, selectedPageSize, onPageChange, onPageSizeChange, changeFilterOptions, isLoading, recordsInfo } = useTableApi(api, true);
  const [openAddModal, setOpenAddModal] = useState({
    status: false,
    data: ""
  });
  const [deleteModal, setDeleteModal] = useState({
    status: false,
    data: ""
  });

  const handleSearch = (e) => {
    if (e.keyCode == 13 || !e.target.value?.length) {
      e.preventDefault();
      changeFilterOptions({ search: e.target.value })
    }
  };

  const handleExport = async (e) => {
    e.preventDefault();
    if (recordsInfo?.totalRecords > 0) {
      const data = await api({ page_size: recordsInfo?.totalRecords, page_number: 0 });
      jsonToXlsx(data?.data?.records, title);
    } else {
      toast.error("No records to export")
    }
  };

  const handleDelete = async () => {
    if (deleteApi) {
      const { ok, message } = await deleteApi({ id: deleteModal?.data?.id });
      if (ok) {
        toast.success(message || "Success");
        changeFilterOptions();
      }
    }
    setDeleteModal();
  };

  const handleCloseAddModal = (apiCall = false) => {
    setOpenAddModal();
    apiCall && changeFilterOptions();
  };

  return (
    <div className="content container-fluid">
      <div className="page-header">
        <div className="row align-items-center">
          <div className="col">
            <h3 className="page-title">{title || "Master Table"}</h3>
          </div>
          <div className="col-auto">
            {showAddButton && <span className="btn btn-primary me-1" onClick={() => setOpenAddModal({ status: true })}>
              <TiPlus size={24} />
            </span>}
            {showExportButton && <a href="add-Influencer.html" className="btn btn-primary me-1" onClick={(e) => handleExport(e)}>
              <MdDownload size={24} />
            </a>}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table">
            <div className="card-body">
              <div className="table-responsive">
                <div className="tbl-search">
                  <input type="text" onKeyUp={handleSearch} className="form-control" placeholder="Search here..."
                  />
                  <button className=" mt-3 mx-2 btn" type="submit">
                    <MdSearch />
                  </button>
                </div>
                {isLoading ?
                  <div class=" mt-4 d-flex justify-content-center">
                    <div class="spinner-border" role="status" />
                  </div>
                  :
                  Boolean(recordsInfo?.data?.length) &&
                  <table className="table table-striped table-bordered ">
                    <thead className="thead">
                      <tr>
                        <th>Serial No</th>
                        {columns.map((item, index) => <th>{item?.label}</th>)}
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {/* {recordsInfo?.data?.slice(pageIndex * 10)?.map((value, index) => ( */}
                        {recordsInfo?.data?.map((value, index) => (
                          <tr>
                            <td>{index + 1 + (pageIndex * 10)}</td>
                            {columns.map((item, index) => <td>{item.renderValue ? item.renderValue(value[item?.value]) : value[item?.value] || "-"}</td>)}
                            <td className="text-center">
                              {
                                !disableEdit &&
                                <span className="btn btn-sm btn-white text-success me-2" onClick={() => setOpenAddModal({ data: value, status: true })}>
                                  <MdEdit className="me-1" /> Edit
                                </span>
                              }
                              <span className="btn btn-sm btn-white text-danger me-2" onClick={() => setDeleteModal({ data: value, status: true })}>
                                <MdDelete className="me-1" />
                                Delete
                              </span>
                            </td>
                          </tr>
                        ))}
                      </>
                    </tbody>
                  </table>}
                <div className="d-flex justify-content-between">
                  {!isLoading && <p className="m-3">{`Total Records: ${recordsInfo?.totalRecords}`}</p>}
                  {recordsInfo?.totalRecords > selectedPageSize &&
                    <ReactPaginate
                      containerClassName={"pagination"}
                      pageClassName={"page-item"}
                      activeClassName={"active"}
                      pageCount={recordsInfo?.totalRecords / 10}
                      onPageChange={(e) => onPageChange(e.selected, true)}
                      pageRangeDisplayed={2}
                      marginPagesDisplayed={1}
                      previousLabel={
                        <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
                          <AiFillLeftCircle />
                        </IconContext.Provider>
                      }
                      nextLabel={
                        <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
                          <AiFillRightCircle />
                        </IconContext.Provider>
                      }
                    />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openAddModal?.status && (addModal(openAddModal, handleCloseAddModal))}
      {deleteModal?.status && <ConfirmModal onClose={setDeleteModal} message="Are you sure want to delete this item." title="Alert!" handleDelete={handleDelete} />}
    </div >
  );
};

export default Table;